import 'remodal';
import Confirmbox from 'components/confirm-box';
import loaderHtml from 'components/loader';
import { Days, apiUrl } from 'config/constants';
import MenuPopup from 'components/menu-popup';
import ImageTools from 'utils/imageTools';

'use strict';

const Events = {

    /**
     * Initialize the events features
     */
    init(options) {
        this.options = options || {};
        this.$editEvent = $('#edit-event');
        this.$editEvent.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$editEventModal = this.$editEvent.remodal({ hashTracking: false });
        this.$eventClone = $('.event-clone').clone().removeClass('hidden').removeClass('.event-clone');
        $('.event-clone').remove();

        $('.js-select-time').flatpickr({
            enableTime: true,
            noCalendar: true,
            dateFormat: 'h K',
            disableMobile: true,
            enableSeconds: false
        });

        window.setTimeout(() => {
            $('input[type="time"]').attr('step', 60);
        }, 1000);

        this.filterClone();

        this.bindEvents();
    },

    filterClone() {
        if (this.options.permissions.isAdmin) {
            this.$eventClone.find('.js-event-controls, .js-open-edit-event, .js-delete-event').removeClass('hidden');
        }
        else if (this.options.permissions.isManager) {
            this.$eventClone.find('.js-event-controls, .js-open-edit-event').removeClass('hidden');
        }

        this.$eventClone.find('.js-event-actions, .js-event-who').removeClass('hidden');
    },

    /**
     * Handle change event of file input
     * @param e {Event} change event object
     */
    handleUpload(e) {

        let file = e.target.files[0],
            $field = $(e.target),
            fileName = e.target.files[0].name,
            lastModifiedDate = new Date(e.target.files[0].lastModified),
            lastModified = e.target.files[0].lastModified,
            reader = new FileReader(),
            image = new Image();

        if (!file.type.match('image/jpeg')) {
            $.snackbar({ content: 'Only the jpg format is allowed.' });
            return;
        }

        reader.readAsDataURL(file);
        this.$editEvent.addClass('is-loading');

        reader.onload = function a(e) {
            image.src = e.target.result;
            image.onload = function b() {

                let imageHeight = this.height;
                let imageWidth = this.width;

                if (imageHeight > 800 || imageWidth > 800) {
                    ImageTools.resize(file, {
                        width: 800,
                        height: 800
                    }, function a(blob, didItResize) {
                        blob.name = fileName;
                        blob.lastModified = lastModified;
                        blob.lastModifiedDate = lastModifiedDate;
                        Events.uploadRequest(blob, $field, fileName);
                    });
                }
                else {
                    Events.uploadRequest(file, $field, fileName);
                }
            };
        };
    },


    /**
     * Async upload request
     * @param file {File}
     * @param $field {jQuery} file input node
     */
    uploadRequest(file, $field, name) {
        let formData = new FormData();
        $.snackbar({ content: 'Please, wait a few seconds.' });

        formData.append('file', file, name);
        $.ajax({
            url: apiUrl + 'images/upload',
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            type: 'post',
            xhrFields: {
                withCredentials: true
            },
            success: (res) => {
                $.snackbar({ content: 'Event image updated!' });
                this.$editEvent.removeClass('is-loading');
                this.$editEvent.find('.js-edit-event-image-url').val(res);
            },
            error: () => {
                $.snackbar({ content: 'We couldn\'t update the event image at the moment. Please try again later!' });
                this.$editEvent.removeClass('is-loading');
                this.$editEvent.find('.js-edit-event-image-url').val('');
            }
        });
    },


    /**
     * Get array of event nodes
     * @param eventsArr
     * @returns {Array}
     */
    getEvents(eventsArr) {

        let $events = [];

        let cityName = '';
        for (let i in eventsArr) {
            if (eventsArr[i]) {
                let $clone = this.$eventClone.clone();

                $clone.attr('id', 'event_' + eventsArr[i].id);
                $clone.data('event', eventsArr[i]);
                $clone.find('.js-event-image').prop('src', eventsArr[i].image);
                $clone.find('.js-event-day').text(Days[eventsArr[i].day_of_week].plural);
                if (eventsArr[i].city != 'undefined') {
                    $clone.find('.js-city-name').text(eventsArr[i].city);
                    cityName = eventsArr[i].city;
                }
                else {
                    $clone.find('.js-city-name').text(eventsArr[i].province);
                    cityName = eventsArr[i].province;
                }
                $clone.find('.js-event-time').text(eventsArr[i].time);
                if (eventsArr[i].neighborhood) {
                    $clone.find('.js-event-place').text(`${eventsArr[i].street_address}, ${eventsArr[i].neighborhood}`);
                }
                else {
                    $clone.find('.js-event-place').text(eventsArr[i].street_address);
                }

                cityName = eventsArr[i].city;

                if (cityName.includes(' ')) {
                    let testing = cityName.split(' ');
                    if (testing.length == 2) {
                        cityName = `${testing[0]}-${testing[1]}`;
                    }
                    else if (testing.length > 2) {
                        cityName = `${testing[0]}-${testing[1]}-${testing[2]}`;
                    }
                }

                $clone.find('.js-event-address').attr('href', `https://www.google.co.uk/maps/search/${window.encodeURIComponent(eventsArr[i].place + ' ' + eventsArr[i].city)}/`).text(eventsArr[i].address);
                $clone.find('.a-event-image').attr('href', `event/${cityName}/${eventsArr[i].id}`);
                $clone.find('.js-event-rsvp').toggleClass('hidden', eventsArr[i].registered).data('eventId', eventsArr[i].id);

                if (this.options.isCityMember === undefined) {
                    this.options.isCityMember = (this.options.permissions.isLoggedIn && this.options.me.cities.find((city) => (city.id == eventsArr[i].city_id))) || this.options.permissions.isAdmin;
                }

                if (this.options.permissions.isLoggedIn) {
                    $clone.find('.js-event-unrsvp').toggleClass('hidden', !eventsArr[i].registered).data('eventId', eventsArr[i].id);
                }

                if (this.options.isCityMember) {
                    $clone.find('.js-event-invite').toggleClass('hidden', !eventsArr[i].registered).attr('href', `users.html?cityId=${eventsArr[i].city_id}&inviteTo=${eventsArr[i].id}`);
                }
                if (eventsArr[i].who) {
                    $clone.find('.js-event-who').attr('href', `event/${cityName}/${eventsArr[i].id}`);
                }
                else {
                    $clone.find('.js-event-who').addClass('hidden');
                }

                $events.push($clone);
            }
        }

        return $events;
    },


    /**
     * Open edit event modal
     * @param e {Event} click event object
     */
    openEditEvent(e) {
        e.preventDefault();

        const event = $(e.target).closest('.event').data('event');

        this.$editEvent.data('id', event.id);
        this.$editEvent.find('input[name=edit-event-file]').val(event.image);
        this.$editEvent.find(`input[name=edit-event-day][value=${event.day_of_week}]`).attr('checked', 'checked');
        this.$editEvent.find('#edit-event-name').val(event.place);
        this.$editEvent.find('#edit-event-address').val(event.street_address);
        this.$editEvent.find('#edit-event-neighborhood').val(event.neighborhood);
        this.$editEvent.find('#edit-event-province').val(event.province);
        this.$editEvent.find('#edit-event-postal-code').val(event.post_code);
        this.$editEvent.find('#edit-event-time').val(event.time);
        this.$editEvent.find('.js-select-time').val(event.time);
        this.$editEvent.find('#edit-event-cname').val(event.contact_name);
        this.$editEvent.find('#edit-event-cnumber').val(event.contact_phone);

        this.$editEvent.find('.form-group').removeClass('is-empty');

        this.$editEventModal.open();
    },


    /**
     * Close edit event modal
     * @param e {Event} click event object
     */
    closeEditEvent(e) {
        e.preventDefault();
        this.$editEventModal.close();
    },


    /**
     * Delete event
     * @param e {Event} click event object
     */
    deleteEventConfirm(e) {
        e.preventDefault();
        let $elem = $(e.target).closest('.event');
        let options = {
            action: 'delete',
            item: 'this Event',
            onAccept: () => {
                window.Api.Event.deleteOne($elem.data('event').id).then((res) => {
                    if (res.isOk) {
                        $elem.fadeOut(500);
                    }
                    else {
                        $.snackbar({ content: 'We couldn\'t delete you event please try again later!' });
                    }
                }, () => {
                    $.snackbar({ content: 'We couldn\'t delete you event please try again later!' });
                });
            }
        };

        Confirmbox.open(options);
    },


    editEventSubmit(e) {
        e.preventDefault();

        let values = {
            image: $('input[name=edit-event-file]').val(),
            'day_of_week': $('[name=edit-event-day]:checked').val(),
            place: $('#edit-event-name').val(),
            'street_address': $('#edit-event-address').val(),
            neighborhood: $('#edit-event-neighborhood').val(),
            province: $('#edit-event-province').val(),
            'post_code': $('#edit-event-postal-code').val(),
            time: $('#edit-event-time').val().trim(),
            'contact_name': $('#edit-event-cname').val(),
            'contact_phone': $('#edit-event-cnumber').val(),
        };

        let hasError = false;

        for (let i in values) {
            if (values.hasOwnProperty(i)) {
                if (values[i]) {
                    values[i] = values[i].trim();
                }

                if (!values[i] || !values[i].length) {
                    hasError = true;
                }
            }
        }

        values['day_of_week'] = parseInt(values.day_of_week);

        if (hasError) {
            $.snackbar({ content: 'All fields are required!' });
            return;
        }

        this.$editEvent.addClass('is-loading');

        window.Api.Event.updateOne(this.$editEvent.data('id'), values).then((res) => {
            this.$editEvent.removeClass('is-loading');

            if (res.isOk) {
                let $event = $('#event_' + this.$editEvent.data('id'));
                let event = $event.data('event');

                event = $.extend(event, values);

                $event.data('event', event);
                $event.find('.js-event-image').prop('src', event.image);
                $event.find('.js-event-day').text(Days[event.day_of_week].plural);
                $event.find('.js-city-name').text(event.city);
                $event.find('.js-event-time').text(event.time);
                $event.find('.js-event-place').text(`${event.street_address}, ${event.neighborhood}`);
                $event.find('.js-event-address').attr('href', `https://www.google.co.uk/maps/search/${window.encodeURIComponent(event.place + ' ' + event.city)}/`).text(event.address);

                this.$editEvent.removeClass('is-loading');
                this.$editEventModal.close();
            }
            else {
                this.$editEvent.removeClass('is-loading');
                $.snackbar({ content: 'We couldn\'t save you event please try again later!' });
            }
        }, () => {
            this.$editEvent.removeClass('is-loading');
            $.snackbar({ content: 'We couldn\'t save you event please try again later!' });
        });
    },

    toggleRsvp(e) {
        e.preventDefault();
        let $elem = $(e.target).closest('a');
        let hadRsvp = $elem.hasClass('js-event-unrsvp');

        if (!this.options.permissions.isLoggedIn) {
            MenuPopup.openPopup(e);
            $.snackbar({ content: 'Please Sign In / Register!' });
            return;
        }
        window.Api.EventUser.toggle($elem.data('eventId')).then((res) => {
            if (res.isOk) {
                $elem.addClass('hidden');
                if (hadRsvp) {
                    $elem.siblings('.js-event-rsvp').removeClass('hidden');
                    if (this.options.isCityMember) {
                        $elem.siblings('.js-event-invite').addClass('hidden');
                    }
                }
                else {
                    $('#rsvpGA').click();
                    $elem.siblings('.js-event-unrsvp').removeClass('hidden');
                    if (this.options.isCityMember) {
                        $elem.siblings('.js-event-invite').removeClass('hidden');
                    }
                }
            }
            else if (res.status === 406) {
                $.snackbar({ content: 'Please set at least one language in your profile.' });
            }
            else {
                $.snackbar({ content: 'We couldn\'t rsvp you to this event. Please try again later' });
            }
        }, () => {
            $.snackbar({ content: 'We couldn\'t rsvp you to this event. Please try again later' });
        });
    },


    /**
     * Bind Events
     */
    bindEvents() {
        $(document).on('click', '.js-delete-event', this.deleteEventConfirm.bind(this));
        $(document).on('click', '.js-open-edit-event', this.openEditEvent.bind(this));
        $(document).on('click', '.js-event-rsvp, .js-event-unrsvp', this.toggleRsvp.bind(this));
        this.$editEvent.on('click', '.js-close-edit-event', this.closeEditEvent.bind(this));
        this.$editEvent.on('submit', '#edit-event-form', this.editEventSubmit.bind(this));
        this.$editEvent.on('change', 'input[type=\'file\']', this.handleUpload.bind(this));
    }
};


export default Events;
